import { useClientsStore } from '@/store/clients';
import { useUsersStore } from '@/store/users';

export const activitiesOptions = {
    searchClientsAndLeads: async (query = '') => {
    const store = useClientsStore();
    await store.searchClientsAndLeads({ 'filter[name]': query });
    return store.clients_leads;
  },
  searchUsers: async (query = '') => {
    const store = useUsersStore();
    await store.searchUsers({ 'filter[name]': query });
    return store.users_result;
  },
};
